import { gql, useMutation } from '@apollo/client';

import { GET_VACANCIES } from './get-vacancies.hook';
import { GET_VACANCY_BY_ID } from './get-vacancy-by-id.hook';

export const CHANGE_VACANCY_STATUS = gql`
  mutation changeVacancyStatus($payload: ChangeVacancyStatusInput!) {
    changeVacancyStatus(payload: $payload) {
      _id
    }
  }
`;

export const useChangeVacancyStatus = ({ onSuccess }: { onSuccess: () => void }) => {
  const [changeVacancyStatus] = useMutation(CHANGE_VACANCY_STATUS, {
    refetchQueries: [GET_VACANCIES, GET_VACANCY_BY_ID],
    onCompleted: onSuccess,
  });

  return { changeVacancyStatus };
};
